import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDT8Jh9kWCSUMOnnYXKweVTx60giwBJbc0",
  authDomain: "bakrtk-84da9.firebaseapp.com",
  projectId: "bakrtk-84da9",
  storageBucket: "bakrtk-84da9.firebasestorage.app",
  messagingSenderId: "870710229093",
  appId: "1:870710229093:web:1042b6e04125244e51ae8c",
  measurementId: "G-LYHBRNLKV2"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
